"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopProductAddOnInputTypeToJSON = exports.ShopProductAddOnInputTypeFromJSONTyped = exports.ShopProductAddOnInputTypeFromJSON = exports.ShopProductAddOnInputType = void 0;
/**
 *
 * @export
 */
exports.ShopProductAddOnInputType = {
    None: 0,
    Text: 1,
    Number: 2
};
function ShopProductAddOnInputTypeFromJSON(json) {
    return ShopProductAddOnInputTypeFromJSONTyped(json, false);
}
exports.ShopProductAddOnInputTypeFromJSON = ShopProductAddOnInputTypeFromJSON;
function ShopProductAddOnInputTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ShopProductAddOnInputTypeFromJSONTyped = ShopProductAddOnInputTypeFromJSONTyped;
function ShopProductAddOnInputTypeToJSON(value) {
    return value;
}
exports.ShopProductAddOnInputTypeToJSON = ShopProductAddOnInputTypeToJSON;
